exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.file-select > .select-button[data-v-b8ef571e] {\n  padding: 1rem;\n  color: white;\n  background-color: #27488e;\n  border-radius: 0.3rem;\n  text-align: center;\n  font-weight: bold;\n  cursor: pointer;\n}\n.file-select > input[type='file'][data-v-b8ef571e] {\n  display: none;\n}\n", ""]);

// exports
